import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";


@Component({
  selector: 'sm-add-tracking-items-details',
  templateUrl: './add-tracking-items-details.component.html',
  styleUrls: ['./add-tracking-items-details.component.scss']
})
export class AddTrackingItemsDetailsComponent implements OnInit,OnDestroy {
  trackingItemValue: any;
  trackingDate: any = new Date();
  today: any = this.formatDate1(new Date());
  trackingNotes: any = null;
  apisub: Subscription
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentdata: any,
    private apiservice: ApiService,
    private ls: LoaderServiceService,
    private activemodal: MatDialogRef<AddTrackingItemsDetailsComponent>
  ) {

    this.apisub = this.apiservice.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_PROGRESS_DATA){
        if(resdata.result){
          this.activemodal.close({msg:'success'})
        }
      }
    })

  }

  ngOnInit(): void {}

  onSave() {
    let obj = {
      tracking_item_hash: this.parentdata.tracking_item_hash,
      tracking_item_value: this.trackingItemValue,
      notes: this.trackingNotes,
      status: 1,
      creation_time: this.trackingDate
        ? this.formatDate1(this.trackingDate)
        : null,
      creator_type: 2,
      created_by: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
    };

     Object.keys(obj).forEach((key) => {
      if ((obj as any)[key] === null || (obj as any)[key] === '' || (obj as any)[key] === undefined) {
        delete (obj as any)[key];
      }
    });

    console.log(obj);
    

    this.ls.showLoader = true;
    this.apiservice.addEditProgressData(obj)
  }

  formatDate1(dateStr: Date) {
    let curdate = new Date(dateStr)
      .toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .slice(0, 10);

    return curdate;
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe()
  }
}
